'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Paper = undefined;

var _templateObject = _taggedTemplateLiteral(['\n\t> div {\n\t\tbox-shadow: ', ';\n\t\tborder-radius: ', ';\n\t\tbackground-color: #fff;\n\t}\n'], ['\n\t> div {\n\t\tbox-shadow: ', ';\n\t\tborder-radius: ', ';\n\t\tbackground-color: #fff;\n\t}\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _globals = require('../globals');

var _globals2 = _interopRequireDefault(_globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Paper = _styledComponents2.default.div(_templateObject, _globals2.default.styles.boxShadow, function (props) {
	return props.circle ? '50%' : '4px';
});

exports.Paper = Paper;